import { getApiClientHeaderForMode } from '@/utils/apiConfig'
import type { NetworkEnvironment } from '@/hooks/useNetworkEnvironment'

export type ModeAwareRequestConfig = {
  headers: Record<string, string>
  __preserveAppClientHeader: boolean
}

export const buildModeAwareConfig = (
  mode?: NetworkEnvironment
): ModeAwareRequestConfig | undefined => {
  if (!mode) {
    return undefined
  }
  return {
    headers: {
      'X-App-Client': getApiClientHeaderForMode(mode),
    },
    __preserveAppClientHeader: true,
  }
}
